module.exports = {
      id: "rss-usage",
      viewBox: "0 0 13 12",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#rss",
      toString: function () {
        return this.url;
      }
    }